import {Team} from '../team';

export class TeamResource extends Team {

  page?: number;
  size?: number;

}
